import React, { PureComponent } from 'react'
import AwsConfig from '../../../Config/AwsConfig'
import {
  heightPercentageToDP as heightPercentage,
  widthPercentageToDP as widthPercentage,
} from '../../../Utils/ResponsiveScreen'
import { KTColors } from '../../Constants/KTColors'
import { fonts } from '../../Constants/theme'
import DynamicButtonView from '../DynamicButtonView'

const styles = {
  container: {
    flex: 1,
    height: heightPercentage('100%'),
  },
  cardContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  card: {
    width: widthPercentage('100'),
    height: heightPercentage('100'),
    shadowColor: 'rgba(0,0,0,0.5)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    justifyContent: 'center',
    alignItems: 'center',
    shadowOpacity: 0.5,
    padding: widthPercentage('5%'),
  },

  questionText: {
    textAlign: 'center',
    fontFamily: fonts.fontFamilyPoppinsLight,
    fontSize: heightPercentage('2.8%'),
    lineHeight: heightPercentage('3.6%'),
    fontWeight: 'bold',
    marginBottom: heightPercentage('1%'),
  },
  buttonText: {
    fontSize: heightPercentage('2.4%'),
    lineHeight: heightPercentage('2.6%'),
    fontFamily: fonts.fontFamilyPoppinsLight,
  },
  button: {
    borderWidth: 0.8,
    opacity: 0.8,
    width: widthPercentage('90%'),
    marginTop: heightPercentage('1.5%'),
  },

  questionsContentPoster: {
    height: heightPercentage('100'),
    resizeMode: 'cover',
    // aspectRatio: width / height,
  },
  questionContainerBorder: {
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    padding: widthPercentage('2.5%'),
    borderRadius: 10,
  },
  titleBgColorStyle: {
    width: widthPercentage('90%'),
    justifyContent: 'center',
    alignItems: 'center',
    left: widthPercentage('5%'),
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    padding: widthPercentage('2.5%'),
    borderRadius: 10,
    borderWidth: 2,
  },
  titleNoBgColor: {
    width: widthPercentage('90%'),
    justifyContent: 'center',
    alignItems: 'center',
    left: widthPercentage('5%'),
    padding: widthPercentage('2.5%'),
  },
  textOverLayContainer: {
    zIndex: 1000,
    position: 'absolute',
    bottom: 0,
    width: widthPercentage('100%'),
  },
  textOverLayHeaderBorder: {
    backgroundColor: KTColors.black40,
    height: heightPercentage('2%'),
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
  },
  textOverLayContent: {
    backgroundColor: KTColors.black40,
    alignContent: 'center',
    alignItems: 'center',
    paddingLeft: widthPercentage('5%'),
    paddingRight: widthPercentage('5%'),
    paddingTop: heightPercentage('3%'),
    paddingBottom: heightPercentage('3%'),
  },
  rectangularOverlayMargin: {
    width: widthPercentage('70'),
    marginLeft: widthPercentage('10'),
    marginRight: widthPercentage('20'),
  },
}

class OnlyCoverView extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      overLayStyle: false,
    }
  }

  renderOnlyCoverInfoV1 = () => {
    const { onlycoverDetails, coverStoryTitle, coverStoryCardDescription } = this.props
    const titleColor =
      onlycoverDetails && onlycoverDetails.textColor ? onlycoverDetails.textColor : KTColors.white

    return (
      <div style={styles.textOverLayContainer}>
        <div style={styles.textOverLayHeaderBorder}></div>
        <div style={styles.textOverLayContent}>
          {coverStoryTitle && (
            <p
              style={{
                fontSize: heightPercentage('3.4%'),
                color: titleColor,
                textAlign: 'center',
                marginBottom: heightPercentage('2%'),
              }}
            >
              {coverStoryTitle}
            </p>
          )}
          {coverStoryCardDescription && (
            <p
              style={{
                fontSize: heightPercentage('2.6%'),
                color: titleColor,
                textAlign: 'center',
              }}
            >
              {coverStoryCardDescription}
            </p>
          )}
        </div>
      </div>
    )
  }

  renderOnlyCoverInfoV2 = () => {
    const { advancedOverlayStyles } = this.props.onlycoverDetails || {}
    const { coverStoryTitle, coverStoryCardDescription } = this.props

    const {
      overlayPositionFromBottom,
      overlayTitleFontSize,
      overlayTitleColor,
      overlayTitleBold,
      enableSeperator,
      seperatorColor,
      overlayDescriptionFontSize,
      overlayDescriptionColor,
      overlayDescriptionBold,
      overlayBgColor,
      advancedOverlayStyleType,
    } = advancedOverlayStyles || ''
    const marginAlignmentStyle =
      advancedOverlayStyleType == 'RectangularBox' ? styles.rectangularOverlayMargin : {}

    return (
      <div
        style={{
          ...styles.textOverLayContainer,
          ...{
            bottom: heightPercentage(overlayPositionFromBottom),
            backgroundColor: overlayBgColor ? overlayBgColor : 'transparent',
          },
          ...marginAlignmentStyle,
        }}
      >
        <div
          style={{
            paddingLeft: widthPercentage('5%'),
            paddingRight: widthPercentage('5%'),
            paddingTop: heightPercentage('1%'),
            paddingBottom: heightPercentage('1%'),
          }}
        >
          <p
            style={{
              fontSize: heightPercentage(overlayTitleFontSize),
              color: overlayTitleColor,
              fontWeight: overlayTitleBold ? 'bold' : 'normal',
            }}
          >
            {coverStoryTitle}
          </p>
          {enableSeperator && (
            <div
              style={{
                marginTop: heightPercentage('1.5%'),
                marginBottom: heightPercentage('1.5%'),
                width: widthPercentage('25%'),
                height: heightPercentage('0.8%'),
                backgroundColor: seperatorColor,
                borderRadius: 5,
              }}
            ></div>
          )}
          <p
            style={{
              fontSize: heightPercentage(overlayDescriptionFontSize),
              color: overlayDescriptionColor,
              fontWeight: overlayDescriptionBold ? 'bold' : 'normal',
            }}
          >
            {coverStoryCardDescription}
          </p>
        </div>
      </div>
    )
  }
  coverStoryVideoURLValidations = () => {
    const { coverStoryVideoURL } = this.props
    return coverStoryVideoURL != '' && coverStoryVideoURL != null && coverStoryVideoURL != undefined
  }
  coverStoryImagesAvailability = () => {
    const { onlycoverDetails } = this.props
    return (
      onlycoverDetails && onlycoverDetails.coverStoryImages && onlycoverDetails.coverStoryImages[0]
    )
  }

  renderCoverStoryVideo = () => {
    const { coverStoryVideoURL } = this.props
    console.log(coverStoryVideoURL, 'coverStoryVideoURL')
    let cdnurl = AwsConfig.cdn_url
    let uri = ''
    if (!uri && coverStoryVideoURL) {
      uri = coverStoryVideoURL
      if (uri && !uri.includes(cdnurl)) {
        uri = cdnurl + coverStoryVideoURL
      }
    }
    return (
      this.coverStoryVideoURLValidations() && (
        <div style={{ height: heightPercentage('100'), backgroundColor: KTColors.black }}>
          <video width={widthPercentage('100')} height={heightPercentage('100')} controls>
            <source src={uri} type='video/mp4' />
          </video>
        </div>
      )
    )
  }

  render() {
    const { onlycoverDetails, coverStoryTitle, coverStoryCardDescription, slideShow } = this.props
    const { isPausedVideo } = this.state
    const pauseVideo = isPausedVideo || this.props.isPausedVideo
    const topPosition =
      onlycoverDetails && onlycoverDetails.contentTitlePosition
        ? onlycoverDetails.contentTitlePosition
        : 50
    const titleColor =
      onlycoverDetails && onlycoverDetails.textColor ? onlycoverDetails.textColor : KTColors.white
    const titleBgColor =
      onlycoverDetails && onlycoverDetails.backGroundTitle
        ? onlycoverDetails.backGroundTitle
        : false
    const coverStoryOriginalImages = onlycoverDetails && onlycoverDetails.coverStoryOriginalImages
    const coverStoryImages = onlycoverDetails && onlycoverDetails.coverStoryImages

    const coverStoryBgImg =
      coverStoryOriginalImages && coverStoryOriginalImages[0]
        ? coverStoryOriginalImages[0].imageValue
        : coverStoryImages && coverStoryImages[0]
          ? coverStoryImages[0].image
          : ''

    let cdnurl = AwsConfig.cdn_url
    const imageWithcdn = coverStoryBgImg ? coverStoryBgImg.includes(cdnurl) ? coverStoryBgImg : cdnurl + coverStoryBgImg : ''
    const styleType = onlycoverDetails && onlycoverDetails.styleType
    const overLayStyle = styleType == 'OverLay' ? true : false
    const textPostionsStyle = !slideShow ? { position: 'absolute' } : null
    const advancedOverlayStyles = onlycoverDetails?.advancedOverlayStyles
    const advancedOverlayStyleType =
      onlycoverDetails?.advancedOverlayStyles?.advancedOverlayStyleType

    return (
      <div style={{ flex: 1, height: heightPercentage('100%') }}>
        <div>
          {this.coverStoryImagesAvailability() && (
            <div
              style={{
                height: heightPercentage('100%'),
                backgroundImage: `url(${imageWithcdn})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              {overLayStyle ? (
                advancedOverlayStyles && advancedOverlayStyleType != 'Default' ? (
                  this.renderOnlyCoverInfoV2()
                ) : (
                  this.renderOnlyCoverInfoV1()
                )
              ) : (
                <div
                  style={
                    titleBgColor
                      ? {
                        ...styles.titleBgColorStyle,
                        ...{ top: heightPercentage(`${topPosition}%`) },
                        ...textPostionsStyle,
                      }
                      : {
                        ...styles.titleNoBgColor,
                        ...{ top: heightPercentage(`${topPosition}%`) },
                        ...textPostionsStyle,
                      }
                  }
                >
                  <div style={styles.questionTextContainer}>
                    <p
                      style={{
                        fontSize: heightPercentage('2.2%'),
                        color: titleColor,
                        fontFamily: fonts.fontFamilyPoppinsLight,
                        textAlign: 'center',
                      }}
                    >
                      {coverStoryTitle}
                    </p>
                    <div style={{ marginTop: heightPercentage('1%') }}>
                      <p
                        style={{
                          fontSize: heightPercentage('1.8%'),
                          color: titleColor,
                          fontFamily: fonts.fontFamilyPoppinsLight,
                          textAlign: 'center',
                        }}
                      >
                        {coverStoryCardDescription}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {this.props.contentNewLinkDetails?.map((item) => {
                return <DynamicButtonView contentNewLinkDetails={item} />
              })}
            </div>
          )}
          {this.renderCoverStoryVideo()}
        </div>
      </div>
    )
  }
}

export default OnlyCoverView
